import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Penetrant} from '../models';

@Injectable()
export class PenetrantService extends IoService {
  protected model = Penetrant;
  protected listUrl = '/penetrants/';
}
